<template>
  <div class="bdgWrp">
    <div class="empty" v-if="!yearLoading && year.length === 0">This venue is not yet linked to Xero.</div>
    <div style="display:flex;width: 100%;" v-if="!yearLoading && year.length > 0">
      <ul class="clear" style="flex:1">
        <li @click="getData(item.year)" :class="{'active': curYear === item.year}" v-for="(item, index) in year" v-bind:key="index">{{item.text}}</li>
      </ul>
      <!--<div class="sigboxItem clear" style="flex: 0 0 auto">
        <el-checkbox style="float:right;margin-right:0" v-model="checked" @change="operate">Tick Activated Manual P&L</el-checkbox>
      </div>-->
    </div>
    <div class="pro-wrp" v-if="!yearLoading && year.length > 0">
      <h2 @click="toggle('trading')">Trading Income<i :class="trading ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i></h2>
      <div class="table-con" v-if="trading">
        <el-table
            :data="tradingIncome"
            border
            style="width: 100%"
            class="alignCenter">
          <el-table-column
            fixed="left"
            width="160"
            prop="name"
            label="Account">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jul"
            label="JUL">
          </el-table-column>
          <el-table-column
            width="138"
            prop="aug"
            label="AUG">
          </el-table-column>
          <el-table-column
            width="138"
            prop="sep"
            label="SEPT">
          </el-table-column>
          <el-table-column  
            width="138"
            prop="oct"
            label="OCT">
          </el-table-column>
          <el-table-column
            width="138"
            prop="nov"
            label="NOV">
          </el-table-column>
          <el-table-column
            width="138"
            prop="dec"
            label="DEC">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jan"
            label="JAN">
          </el-table-column>
          <el-table-column
            width="138"
            prop="feb"
            label="FEB">
          </el-table-column>
          <el-table-column
            width="138"
            prop="mar"
            label="MAR">
          </el-table-column>
          <el-table-column
            width="138"
            prop="apr"
            label="APR">
          </el-table-column>
          <el-table-column
            width="138"
            prop="may"
            label="MAY">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jun"
            label="JUN">
          </el-table-column>
          <el-table-column
            width="138"
            prop="total"
            label="Total">
          </el-table-column>
          <el-table-column
            width="138"
            prop="proportion"
            label="Proportion">
          </el-table-column>
          <template slot="empty">
            <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
            <div v-else>-</div>
          </template>
        </el-table>
      </div>
    </div>
    <div class="pro-wrp" v-if="!yearLoading && year.length > 0">
      <h2 @click="toggle('cost')">Cost of Sales<i :class="trading ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i></h2>
      <div class="table-con" v-if="cost">
        <el-table
            :data="costofSales"
            border
            style="width: 100%"
            class="alignCenter">
          <el-table-column
            fixed="left"
            width="160"
            prop="name"
            label="Account">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jul"
            label="JUL">
          </el-table-column>
          <el-table-column
            width="138"
            prop="aug"
            label="AUG">
          </el-table-column>
          <el-table-column
            width="138"
            prop="sep"
            label="SEPT">
          </el-table-column>
          <el-table-column  
            width="138"
            prop="oct"
            label="OCT">
            <template slot-scope="scope">
              <div v-if="scope.row.oct && parseFloat(scope.row.oct) >= 0">{{scope.row.oct}}</div>
              <div v-if="scope.row.oct && parseFloat(scope.row.oct) < 0">{{scope.row.oct}}</div>
            </template>
          </el-table-column>
          <el-table-column
            width="138"
            prop="nov"
            label="NOV">
          </el-table-column>
          <el-table-column
            width="138"
            prop="dec"
            label="DEC">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jan"
            label="JAN">
          </el-table-column>
          <el-table-column
            width="138"
            prop="feb"
            label="FEB">
          </el-table-column>
          <el-table-column
            width="138"
            prop="mar"
            label="MAR">
          </el-table-column>
          <el-table-column
            width="138"
            prop="apr"
            label="APR">
          </el-table-column>
          <el-table-column
            width="138"
            prop="may"
            label="MAY">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jun"
            label="JUN">
            <template slot-scope="scope">
              <div v-if="scope.row.jun && parseFloat(scope.row.jun) >= 0">{{scope.row.jun}}</div>
              <div v-if="scope.row.jun && parseFloat(scope.row.jun) < 0">{{scope.row.jun}}</div>
            </template>
          </el-table-column>
          <el-table-column
            width="138"
            prop="total"
            label="Total">
          </el-table-column>
          <el-table-column
            width="138"
            prop="percentage"
            label="Proportion">
          </el-table-column>
          <template slot="empty">
            <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
            <div v-else>-</div>
          </template>
        </el-table>
      </div>
    </div>
    <div class="pro-wrp" v-if="!yearLoading && year.length > 0">
      <h2 @click="toggle('gross')">Gross Profit<i :class="trading ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i></h2>
      <div class="table-con" v-if="gross">
        <el-table
            :data="grossProfit"
            border
            style="width: 100%"
            class="alignCenter">
          <el-table-column
            fixed="left"
            width="160"
            prop="name"
            label="Account">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jul"
            label="JUL">
          </el-table-column>
          <el-table-column
            width="138"
            prop="aug"
            label="AUG">
          </el-table-column>
          <el-table-column
            width="138"
            prop="sep"
            label="SEPT">
          </el-table-column>
          <el-table-column  
            width="138"
            prop="oct"
            label="OCT">
          </el-table-column>
          <el-table-column
            width="138"
            prop="nov"
            label="NOV">
          </el-table-column>
          <el-table-column
            width="138"
            prop="dec"
            label="DEC">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jan"
            label="JAN">
          </el-table-column>
          <el-table-column
            width="138"
            prop="feb"
            label="FEB">
          </el-table-column>
          <el-table-column
            width="138"
            prop="mar"
            label="MAR">
          </el-table-column>
          <el-table-column
            width="138"
            prop="apr"
            label="APR">
          </el-table-column>
          <el-table-column
            width="138"
            prop="may"
            label="MAY">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jun"
            label="JUN">
          </el-table-column>
          <el-table-column
            width="138"
            prop="total"
            label="Total">
          </el-table-column>
          <el-table-column
            width="138"
            prop="proportion"
            label="Proportion">
          </el-table-column>
          <template slot="empty">
            <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
            <div v-else>-</div>
          </template>
        </el-table>
      </div>
    </div>
    <div class="pro-wrp" v-if="!yearLoading && year.length > 0">
      <h2 @click="toggle('other')">Other Income<i :class="trading ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i></h2>
      <div class="table-con" v-if="other">
        <el-table
            :data="otherIncome"
            border
            style="width: 100%"
            class="alignCenter">
          <el-table-column
            fixed="left"
            width="160"
            prop="name"
            label="Account">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jul"
            label="JUL">
          </el-table-column>
          <el-table-column
            width="138"
            prop="aug"
            label="AUG">
          </el-table-column>
          <el-table-column
            width="138"
            prop="sep"
            label="SEPT">
          </el-table-column>
          <el-table-column  
            width="138"
            prop="oct"
            label="OCT">
          </el-table-column>
          <el-table-column
            width="138"
            prop="nov"
            label="NOV">
          </el-table-column>
          <el-table-column
            width="138"
            prop="dec"
            label="DEC">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jan"
            label="JAN">
          </el-table-column>
          <el-table-column
            width="138"
            prop="feb"
            label="FEB">
          </el-table-column>
          <el-table-column
            width="138"
            prop="mar"
            label="MAR">
          </el-table-column>
          <el-table-column
            width="138"
            prop="apr"
            label="APR">
          </el-table-column>
          <el-table-column
            width="138"
            prop="may"
            label="MAY">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jun"
            label="JUN">
            <template slot-scope="scope">
              <div v-if="scope.row.jun && parseFloat(scope.row.jun) >= 0">{{scope.row.jun}}</div>
              <div v-else-if="scope.row.jun && parseFloat(scope.row.jun) < 0">{{scope.row.jun}}</div>
              <div v-else>{{scope.row.average}}</div>
            </template>
          </el-table-column>
          <el-table-column
            width="138"
            prop="total"
            label="Total">
          </el-table-column>
          <el-table-column
            width="138"
            prop="proportion"
            label="Proportion">
          </el-table-column>
          <template slot="empty">
            <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
            <div v-else>-</div>
          </template>
        </el-table>
      </div>
    </div>
    <div class="pro-wrp" v-if="!yearLoading && year.length > 0">
      <h2 @click="toggle('operating')">Operating Expenses<i :class="trading ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i></h2>
      <div class="table-con" v-if="operating">
        <el-table
            :data="operatingExpenses"
            border
            style="width: 100%"
            class="alignCenter">
          <el-table-column
            fixed="left"
            width="160"
            prop="name"
            label="Account">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jul"
            label="JUL">
          </el-table-column>
          <el-table-column
            width="138"
            prop="aug"
            label="AUG">
          </el-table-column>
          <el-table-column
            width="138"
            prop="sep"
            label="SEPT">
          </el-table-column>
          <el-table-column  
            width="138"
            prop="oct"
            label="OCT">
          </el-table-column>
          <el-table-column
            width="138"
            prop="nov"
            label="NOV">
          </el-table-column>
          <el-table-column
            width="138"
            prop="dec"
            label="DEC">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jan"
            label="JAN">
          </el-table-column>
          <el-table-column
            width="138"
            prop="feb"
            label="FEB">
          </el-table-column>
          <el-table-column
            width="138"
            prop="mar"
            label="MAR">
          </el-table-column>
          <el-table-column
            width="138"
            prop="apr"
            label="APR">
          </el-table-column>
          <el-table-column
            width="138"
            prop="may"
            label="MAY">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jun"
            label="JUN">
          </el-table-column>
          <el-table-column
            width="138"
            prop="total"
            label="Total">
          </el-table-column>
          <el-table-column
            width="138"
            prop="percentage"
            label="Proportion">
          </el-table-column>
          <template slot="empty">
            <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
            <div v-else>-</div>
          </template>
        </el-table>
      </div>
    </div>
    
    <div class="pro-wrp" v-if="!yearLoading && year.length > 0">
      <h2 @click="toggle('wage')">Wages & Superannuation<i :class="trading ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i></h2>
      <div class="table-con" v-if="wage">
        <el-table
            :data="wage"
            border
            style="width: 100%"
            class="alignCenter">
          <el-table-column
            fixed="left"
            width="160"
            prop="name"
            label="Account">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jul"
            label="JUL">
          </el-table-column>
          <el-table-column
            width="138"
            prop="aug"
            label="AUG">
          </el-table-column>
          <el-table-column
            width="138"
            prop="sep"
            label="SEPT">
          </el-table-column>
          <el-table-column  
            width="138"
            prop="oct"
            label="OCT">
          </el-table-column>
          <el-table-column
            width="138"
            prop="nov"
            label="NOV">
          </el-table-column>
          <el-table-column
            width="138"
            prop="dec"
            label="DEC">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jan"
            label="JAN">
          </el-table-column>
          <el-table-column
            width="138"
            prop="feb"
            label="FEB">
          </el-table-column>
          <el-table-column
            width="138"
            prop="mar"
            label="MAR">
          </el-table-column>
          <el-table-column
            width="138"
            prop="apr"
            label="APR">
          </el-table-column>
          <el-table-column
            width="138"
            prop="may"
            label="MAY">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jun"
            label="JUN">
          </el-table-column>
          <el-table-column
            width="138"
            prop="total"
            label="Total">
          </el-table-column>
          <el-table-column
            width="138"
            prop="percentage"
            label="Proportion">
          </el-table-column>
          <template slot="empty">
            <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
            <div v-else>-</div>
          </template>
        </el-table>
      </div>
    </div>
    <div class="pro-wrp" v-if="!yearLoading && year.length > 0">
      <h2 @click="toggle('net')">Net Profit<i :class="trading ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i></h2>
      <div class="table-con" v-if="net">
        <el-table
            :data="netProfit"
            border
            style="width: 100%"
            class="alignCenter">
          <el-table-column
            fixed="left"
            width="160"
            prop="name"
            label="Account">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jul"
            label="JUL">
          </el-table-column>
          <el-table-column
            width="138"
            prop="aug"
            label="AUG">
          </el-table-column>
          <el-table-column
            width="138"
            prop="sep"
            label="SEPT">
          </el-table-column>
          <el-table-column  
            width="138"
            prop="oct"
            label="OCT">
          </el-table-column>
          <el-table-column
            width="138"
            prop="nov"
            label="NOV">
          </el-table-column>
          <el-table-column
            width="138"
            prop="dec"
            label="DEC">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jan"
            label="JAN">
          </el-table-column>
          <el-table-column
            width="138"
            prop="feb"
            label="FEB">
          </el-table-column>
          <el-table-column
            width="138"
            prop="mar"
            label="MAR">
          </el-table-column>
          <el-table-column
            width="138"
            prop="apr"
            label="APR">
          </el-table-column>
          <el-table-column
            width="138"
            prop="may"
            label="MAY">
          </el-table-column>
          <el-table-column
            width="138"
            prop="jun"
            label="JUN">
          </el-table-column>
          <el-table-column
            width="138"
            prop="total"
            label="Total">
          </el-table-column>
          <el-table-column
            width="138"
            prop="percentage"
            label="Proportion">
          </el-table-column>
          <template slot="empty">
            <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
            <div v-else>-</div>
          </template>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../api/account'
import axios from 'axios'
const CancelToken = axios.CancelToken;

export default {
  data () {
    return {
      checked: false,
      source: CancelToken.source(),
      loading: true,
      trading: true,
      cost: true,
      gross: true,
      other: true,
      operating: true,
      net: true,
      wage: true,
      year: [],
      yearLoading: true,
      curYear: '',
      tradingIncome: [],
      costofSales: [],
      grossProfit: [],
      otherIncome: [],
      operatingExpenses: [],
      netProfit: [],
      wage: [],
      denominator: 0,
    }
  },
  created() {
    if (!this.$route.params.id) {
      return
    }
    api.profitLossOfYearList({
      params: {
        venueId: parseInt(this.$route.params.id)
      },
      callback: this.proCallback
    })
  },
  methods: {
    /*operate () {
      if (this.checked === true) {
        this.$box.loadings()
        api.profitLossEdit({
          params: {
            profitLossEdit: 1,
            venueId: this.$route.params.id
          },
          callback: (res) => {
            this.$box.loadings(2)
            if (res.data.code === 0) {
              //
            } else{
              this.checked = false
              Utils.alert('', res.data.message, 'error')
            }
          }
        })
      } else {
        this.$box.loadings()
        api.profitLossEdit({
          params: {
            profitLossEdit: 0,
            venueId: this.$route.params.id
          },
          callback: (res) => {
            this.$box.loadings(2)
            if (res.data.code === 0) {
              //
            } else{
              this.checked = true
              Utils.alert('', res.data.message, 'error')
            }
          }
        })
      }
    },*/
    proCallback (res) {
      this.yearLoading = false
      if (res.data.code === 0) {
        if (res.data.data) {
          res.data.data.profitLossOfYearList.forEach((item, index) => {
            this.year.push({
              year: item.date,
              text: item.value
            })
          })
          if (res.data.data.profitLossOfYearList.length > 0) {
            this.year[0].text = 'Year to Date'
            this.curYear = this.year[0].year
            api.proLoss({
              params: {
                venueId: parseInt(this.$route.params.id),
                date: this.curYear
              },
              cancelToken: this.source.token,
              callback: this.callback
            })
          }
          if (res.data.data.profitLossEdit === 1) {
            this.checked = true
          }
        }
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    toggle (type) {
      if (type == 'trading') {
        this.trading = !this.trading
      } else if (type == 'cost') {
        this.cost = !this.cost
      } else if (type == 'gross') {
        this.gross = !this.gross
      } else if (type == 'other') {
        this.other = !this.other
      } else if (type == 'operating') {
        this.operating = !this.operating
      } else if (type == 'net') {
        this.net = !this.net
      } else if (type == 'wage') {
        this.wage = !this.wage
      }
    },
    
    callback (res) {
      var that = this
      that.loading = false
      if (res.data.code === 0) {
        res.data.data.forEach((item) => {
          item.profitLossList.forEach(i => {
            i.apr = i.apr !== null ? that.formatDecimal2(i.apr, 2) : null
            i.aug = i.aug !== null ? that.formatDecimal2(i.aug, 2) : null
            i.dec = i.dec !== null ? that.formatDecimal2(i.dec, 2) : null
            i.feb = i.feb !== null ? that.formatDecimal2(i.feb, 2) : null
            i.jan = i.jan !== null ? that.formatDecimal2(i.jan, 2) : null
            i.jul = i.jul !== null ? that.formatDecimal2(i.jul, 2) : null
            i.jun = i.jun !== null ? that.formatDecimal2(i.jun, 2) : null
            i.mar = i.mar !== null ? that.formatDecimal2(i.mar, 2) : null
            i.may = i.may !== null ? that.formatDecimal2(i.may, 2) : null
            i.nov = i.nov !== null ? that.formatDecimal2(i.nov, 2) : null
            i.oct = i.oct !== null ? that.formatDecimal2(i.oct, 2) : null
            i.sep = i.sep !== null ? that.formatDecimal2(i.sep, 2) : null
            i.total = i.total !== null ? that.formatDecimal2(i.total, 2) : null
            i.percentage = i.percentage !== null ? that.formatDecimal2(i.percentage, 2) + '%' : null
          })
          if (item.title === "Other Income") {
            that.otherIncome = item.profitLossList
          }
          else if (item.title === "Cost of Sales") {
            that.costofSales = item.profitLossList
          }
          else if (item.title === "Trading Income") {
            that.tradingIncome = item.profitLossList
          }
          else if (item.title === 'Gross Profit') {
            that.grossProfit = item.profitLossList
          }
          else if (item.title === 'Net Profit') {
            that.netProfit = item.profitLossList
          }
          else if (item.title === 'Operating Expenses') {
            that.operatingExpenses = item.profitLossList
          }
          else if (item.title === 'Wages & Superannuation') {
            that.wage = item.profitLossList
          }
        })
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    formatDecimal(num, decimal) {
      if (num === null){
        return null
    }
      if (num == 0) {
        return '0.00'
      }
      num = num.toString()
      let index = num.indexOf('.')
      if (index !== -1) {
        num = num.substring(0, decimal + index + 1)
      } else {
        num = num.substring(0)
      }
      return parseFloat(num).toFixed(decimal)
    },
    formatDecimal2 (s, type) {
      if (s== 0) {
        return "0.00";
      }
      if (!s) {
        return null
      }
      if (s == null || s == "") {
        return '';
      }
      if (JSON.stringify(s).indexOf('.') === -1) {
        type = 0
      }
      s = s < 0 && type === 0 ? s.toString().replace(/^(\d*)$/, "$1.") + '.' : s.toString().replace(/^(\d*)$/, "$1.");
      s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
      if (type == 0) {// 不带小数位(默认是有小数位)
        var a = s.split(".");
        if (a[1] == "00") {
          s = a[0];
        }
      }
      if (s.indexOf('.') === -1)
        s = s + '.00'
      return s;
},
    getData (year) {
      // 如果前面的请求还没结束，就把它取消掉
      if (this.loading) {
        this.source.cancel('Operationcanceled');
        this.source = null
        this.source = CancelToken.source();
      }
      this.curYear = year
      this.loading = true
      this.tradingIncome = []
      this.costofSales = []
      this.grossProfit = []
      this.otherIncome = []
      this.operatingExpenses = []
      this.netProfit = []
      if (this.loading) {
        this.source.cancel('Operationcanceled');
        this.source = null
        this.source = CancelToken.source();
      }
      api.proLoss({
        params: {
          venueId: parseInt(this.$route.params.id),
          date: this.curYear
        },
        cancelToken: this.source.token,
        callback: this.callback
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bdgWrp{
  width: 100%;
  margin-bottom: 30px;
  background: #2B3444;
  box-sizing: border-box;
  padding: 50px 30px 30px 30px;
  ul{
    width: 100%;
    margin-bottom: 22px;
    li{
      width:140px;
      height:40px;
      float: left;
      background-color: transparent;
      font-size:18px;
      font-family:'PingFangSC-Semibold';
      color: #fff;
      border:2px solid rgba(255,255,255,1);
      text-align:center;
      line-height: 40px;
      cursor: pointer;
    }
    .active{
      border:2px solid rgba(234,55,150,1);
      color: rgba(234,55,150,1);
    }
  }
  .pro-wrp{
    width: 100%;
    background: #151C27;
    margin-bottom: 30px;
    h2{
      width: 100%;
      box-sizing: border-box;
      padding: 21px 0 21px 30px;
      font-size: 20px;
      line-height: 28px;
      color: #fff;
      position: relative;
      i{
        position: absolute;
        right: 20px;
        top: 32px;
      }
    }
    .table-con{
      overflow: hidden;
      transition: all .5s;
    }
  }
  .empty{
    font-size: 20px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/proLoss/index.vue